<template>
  <!-- 此处为入口 公共部分可以放到这里 -->
  <div id="app">
    <publicHeader></publicHeader>
    <router-view :height="height"/>
  </div>
</template>

<script>
import publicHeader from '@/components/PublicHeader'
import error from '@/services/error'

export default {
  name: 'app',
  components: {
    publicHeader
  },
  computed: {
    height() {
      return document.documentElement.clientHeight - 46
    }
  },
  mounted() {
    // 全局错误初始化
    error.init.call(this)
  }
}
</script>

<style>
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
  padding: 0;
  margin: 0;
  height:100%;
  overflow: hidden;
  min-width: 1300px;
}
</style>



// WEBPACK FOOTER //
// src/App.vue